import { useRef } from 'react'
import { DriveContact } from '@/models/drive.ts'
import ContactInfoModal from '@/components/ContactInfoModal.tsx'
import { useTrackStat } from '@/contexts/statsScopeContext.tsx'

interface PhotosByContactProps {
  contact: DriveContact | null
  className?: string
}

export default function PhotosByContact({ contact, className = '' }: PhotosByContactProps) {
  const modalRef = useRef<HTMLDialogElement>(null)
  const track = useTrackStat()

  if (!contact?.first_name) return null

  function openContact() {
    track('contact_view')
    modalRef.current?.showModal()
  }

  return (
    <>
      <button
        className={`text-sm text-content hover:opacity-75 transition-opacity cursor-pointer ${className} tracking-wider`}
        onClick={openContact}
      >
        Fotos von <span className='underline'>{contact.first_name}</span>
      </button>
      <ContactInfoModal contact={contact} modalRef={modalRef} />
    </>
  )
}
